

export default class ShareButtons {
    constructor(element) {

        this.el = element

        this.createButtons()
    }

    createButtons() {
        const facebook = document.createElement('a')
        facebook.classList.add('facebook')
        facebook.setAttribute('href', 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href)
        facebook.setAttribute('target', '_blank')
        facebook.setAttribute('rel', 'noopener')
        facebook.innerHTML = '<svg class="icon icon-facebook"><use xlink:href="#icon-facebook"></use></svg>'

        const twitter = document.createElement('a')
        twitter.classList.add('twitter')
        twitter.setAttribute('href', 'https://twitter.com/intent/tweet?url=' + window.location.href)
        twitter.setAttribute('target', '_blank')
        twitter.setAttribute('rel', 'noopener')
        twitter.innerHTML = '<svg class="icon icon-twitter"><use xlink:href="#icon-x"></use></svg>'

        const linkedin = document.createElement('a')
        linkedin.classList.add('linkedin')
        linkedin.setAttribute('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + window.location.href)
        linkedin.setAttribute('target', '_blank')
        linkedin.setAttribute('rel', 'noopener')
        linkedin.innerHTML = '<svg class="icon icon-linkedin"><use xlink:href="#icon-linkedin"></use></svg>'


        this.el.appendChild(twitter)
        this.el.appendChild(facebook)
        this.el.appendChild(linkedin)
    }

}
